export const letOneDecimal = (num: number) => {
  return Math.round(num * 10) / 10;
};

export const roundValueKeepUnit = (value: string): string => {
  const match = value.match(/^(-?[\d.]+)(.*)$/);
  if (!match) return value;
  const rounded = Math.round(parseFloat(match[1]) * 10) / 10;
  return `${rounded}${match[2]}`;
};
